import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerService } from '../_services/customer.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {
  constructor(private customerService: CustomerService, private toastr: ToastrService) {

  }


  canActivate(): Observable<boolean> {
    return this.customerService.currentUser$.pipe(
      map(user => {
        if (user.roles.includes('Admin') || user.roles.includes('Moderator')){
          return true;
        }
        this.toastr.error('You cannot enter this area');
      })
    );
  }
  
}
